<template>
  <div>
    <div id="content">
      <div id="left">
<!--        <h1 style="height: 32px;margin-top: 4px;margin-bottom: 4px;">-->
<!--          &nbsp;Welcome to Human Cancer SRT Database!-->
<!--        </h1>-->
        <h2 style="width: 100%; text-align: left;margin: 0;padding: 0;"><span style="margin-left: 10px">Human Cancer Types</span></h2>
        <div id="background">
          <!--["Breast cancer", "PDAC", "Skin cancer", "Melanoma", "Prostate cancer",
  "Liver cancer", "Ovarian cancer","Glioblastoma","Colorectal Cancer", "Lung cancer"],-->
          <div id="ProstateCancer" v-on:click="routerTo(4,'ProstateCancer')"/>
          <div id="Melanoma" v-on:click="routerTo(3,'Melanoma')"/>
          <div id="SkinCancer" v-on:click="routerTo(2,'SkinCancer')"/>
          <div id="ColonCancer" v-on:click="routerTo(8,'ColorectalCancer')"/>
          <div id="LiverCancer" v-on:click="routerTo(5,'LiverCancer')"/>
          <div id="BreastCancer" v-on:click="routerTo(0,'BreastCancer')"/>
          <div id="OvarianCancer" v-on:click="routerTo(6,'OvarianCancer')"/>
          <div id="Glioblastoma" v-on:click="routerTo(7,'Glioblastoma')"/>
          <div id="PDAC" v-on:click="routerTo(1,'PDAC')"/>
          <div id="LungCancer" v-on:click="routerTo(13,'LungCancer')"/>
<!--          <div id="IntestineCancer" v-on:click="routerTo(10,'IntestineCancer')"/>-->
          <div id="BladderCancer" v-on:click="routerTo(11,'BladderCancer')"/>
          <div id="CervicalCancer" v-on:click="routerTo(9,'CervicalCancer')"/>
          <div id="BrainMetastases" v-on:click="routerTo(12,'BrainMetastases')"/>
          <div id="HeadNeckCancer" v-on:click="routerTo(14,'HeadNeckCancer')"/>

        </div>
      </div>
      <div id="right">
<!--        <div style="width: 90%;margin: 0;border: #696969 solid 1px;">-->
<!--          <h2 style="width: 100%; text-align: left;margin: 0;border: 0;border-radius:0;"><span style="margin-left: 10px">Cancer types</span></h2>-->
<!--          <div id="tag_list">-->
<!--            <div v-on:click="routerTo(3,'ProstateCancer')">ProstateCancer</div>-->
<!--            <div v-on:click="routerTo(4,'Melanoma')">Melanoma</div>-->
<!--            <div v-on:click="routerTo(1,'SkinCancer')">SkinCancer</div>-->
<!--            <div v-on:click="routerTo(7,'ColonCancer')">ColonCancer</div>-->
<!--            <div v-on:click="routerTo(8,'KidneyCancer')">LiverCancer</div>-->
<!--            <div v-on:click="routerTo(0,'BreastCancer')">BreastCancer</div>-->
<!--            <div v-on:click="routerTo(5,'OvarianCancer')">OvarianCancer</div>-->
<!--            <div v-on:click="routerTo(6,'Glioblastoma')">Glioblastoma</div>-->
<!--            <div v-on:click="routerTo(2,'PDAC')">PDAC</div>-->
<!--            <div v-on:click="routerTo(9,'LungCancer')">LungCancer</div>-->
<!--          </div>-->
<!--        </div>-->
        <div style="width: 100%;min-width: 350px">
          <h2 style="width: 100%; text-align: left;margin: 0;padding: 0;"><span style="margin-left: 10px">Keyword Cloud</span></h2>
          <div class="tagcloud-all" ref="tagcloudall">
            <a v-for="item in tagList" :href="item.url" rel="external nofollow" :key="item.name" :style="{ 'color': item.color}">{{item.name}}</a>
          </div>
        </div>
        <div style="width: 100%;bottom: 0;min-width: 350px;height: 250px">
          <h2 style="width: 100%; text-align: left;margin: 0;padding: 0;"><span style="margin-left: 10px">Statistic</span></h2>
          <div id="statistic">
            <el-form label-width="250"  id="statistic_form">
              <el-form-item>
                <span slot="label">
                  <span style="color: black; font-size: 14px"><strong>No. cancer types:</strong></span>
                </span>
                <span style="float: right; font-size: 14px"><b>14</b></span>
              </el-form-item>
              <el-form-item>
                <span slot="label">
                  <span style="color: black; font-size: 14px"><strong>No. SRT datasets(sub):</strong></span>
                </span>
                <span style="float: right; font-size: 14px"><b>46(347)</b></span>
              </el-form-item>
              <el-form-item>
                <span slot="label">
                  <span style="color: black; font-size: 14px"><strong>No. SRT technologies:</strong></span>
                </span>
                <span style="float: right; font-size: 14px"><b>5</b></span>
              </el-form-item>
              <el-form-item>
                <span slot="label">
                  <span style="color: black; font-size: 14px"><strong>No. samples/spots:</strong></span>
                </span>
                <span style="float: right; font-size: 14px"><b>1,069,377</b></span>
              </el-form-item>
              <el-form-item>
                <span slot="label">
                  <span style="color: black; font-size: 14px"><strong>Datasets with spatial domain annotation:</strong></span>
                </span>
                <span style="float: right; font-size: 14px"><b>54</b></span>
              </el-form-item>
            </el-form>
<!--&lt;!&ndash;            <div>No. cancer type:&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&ensp;&nbsp;10</div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div style="white-space:pre">No. SRT datasets(sub):&emsp;&emsp;&emsp;&ensp;&nbsp;12(44)</div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div style="white-space:pre">No. SRT technologies:&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&ensp;3</div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div style="white-space:pre">No. samples:&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;21308</div>&ndash;&gt;-->
<!--&lt;!&ndash;            <div style="white-space:pre">No. genes:&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;207317</div>&ndash;&gt;-->
          </div>
        </div>
      </div>
    </div>

<!--    <img src="../assets/home.jpg" alt="asd">-->

    <div class="my-container" style="min-width: 1200px">
      <h2>Search CancerSRT</h2>
      <el-form :model="form" label-width="300px" style="margin-top: 20px" size="mini">
        <el-form-item>
<!--          <el-form-item label="Type:">-->
          <span slot="label">
              <span style="color: black;font-size: 18px"><strong>Type:</strong></span>
          </span>
          <el-select v-model="form.Type" placeholder="please select" style="width: 200px;float: left">
            <el-option label="all" value="all"></el-option>
            <el-option label="Breast cancer" value="Breast Cancer"></el-option>
            <el-option label="PDAC" value="PDAC"></el-option>
            <el-option label="cSCC" value="cSCC"></el-option>
            <el-option label="Melanoma" value="Melanoma"></el-option>
            <el-option label="Prostate Cancer" value="prostate cancer"></el-option>
            <el-option label="Liver Cancer" value="liver cancer"></el-option>
            <el-option label="Ovarian Cancer" value="OvarianCancer"></el-option>
            <el-option label="Glioblastoma" value="Glioblastoma"></el-option>
            <el-option label="Colorectal Cancer" value="Colorectal Cancer"></el-option>
            <el-option label="Cervical Cancer" value="Cervical Cancer"></el-option>
<!--            <el-option label="Intestine Cancer" value="Intestine Cancer"></el-option>-->
            <el-option label="Bladder Cancer" value="Bladder Cancer"></el-option>
            <el-option label="Brain Metastases" value="Brain metastases"></el-option>
            <el-option label="Lung Cancer" value="Lung cancer"></el-option>
            <el-option label="Head and neck cancer" value="Head and neck cancer"></el-option>
          </el-select>
          <span style="float: left;margin-left: 20px;color: black;font-size: 18px">Please select cancer type to browse.</span>
        </el-form-item>
        <el-form-item label="Gene or ENSEMBL ID:">
          <span slot="label">
              <span style="color: black;font-size: 18px"><strong>Gene Symbol or Ensembl ID:</strong></span>
          </span>
          <el-input v-model="form.Gene" placeholder="e.g. A1BG" style="width: 200px;float: left"></el-input>
          <span style="float: left;margin-left: 20px;color: black;font-size: 18px">Please input Gene or ENSEMBL ID: such as A1BG or ENSG00000121410.</span>
        </el-form-item>
        <el-button size="mini" type="info" round @click="onSubmit" style="margin-bottom: 10px" id="search_button_home">Search</el-button>
      </el-form>
<!--      <scan>&nbsp;&nbsp;&nbsp;&nbsp;Please select species to browse.</scan>-->
<!--      <scan>&nbsp;&nbsp;&nbsp;&nbsp;Please input Gene or ENSEMBL ID: such as Kctd12 or ENSMUSG00000098557.</scan>-->
    </div>

    <div class="my-container">
      <h2>Introduction for CancerSRT</h2>
      <div class="my-div-center">
        <div style="text-align: justify;width: 80%;word-spacing: 5px;line-height: 30px;font-size: 18px;margin-bottom: 5px;color: black">
          <p style="text-indent: 2em">
            The current version of CancerSRT contains <b>45</b> spatial transcriptomics datasets (<b>346</b> sub-datasets) covering <b>14</b> cancer types,
            including <i>breast cancer (BRCA)</i>, <i>prostate cancer (PRCA)</i>, <i>melanoma (MELA)</i>,
            <i>pancreatic ductal adenocarcinomas (PDAC)</i>, <i>squamous cell carcinoma (SCC)</i>,
            <i>ovarian cancer (OVCA)</i>, <i>glioblastoma (GBM)</i>, <i>colorectal cancer (CRC)</i>, <i>cervical cancer (CECA)</i>,
            <i>brain metastases</i>, <i>bladder cancer (BLCA)</i>, <i>liver cancer (LICA)</i>,
            <i>lung cancer (LUCA)</i> and <i>head and neck cancer (HNC)</i>. These datasets are generated by four spatial technologies, i.e.,
            10x Visium, ST, LCM-seq and Slide-seqV2.
          </p>
        </div>
      </div>
    </div>


    <div class="my-container">
      <h2>Functions of CancerSRT</h2>
      <div class="my-div-center">
        <div style="text-align: justify;width: 80%;word-spacing: 5px;line-height: 30px;font-size: 18px;margin-bottom: 5px;color: black">
          <p style="text-indent: 2em;padding-top: 0;padding-bottom: 0;margin-top: 0;margin-bottom: 0">
            At the <b>gene dimension</b>, we performed marker genes detection, SVGs identification, and spatially patterned enrichment.
          </p>
          <p style="text-indent: 2em;padding-top: 0;padding-bottom: 0;margin-top: 0;margin-bottom: 0">
            At the <b>cellular dimension</b>, we identified cell types through mapping and deconvolution and inferred cell-cell interactions.
          </p>
          <p style="text-indent: 2em;padding-top: 0;padding-bottom: 0;margin-top: 0;margin-bottom: 0">
            In <b>cancer-specific analysis</b>, we differentiated tumor cells and calculated the cancer functional state enrichment scores.
          </p>
          <p style="text-indent: 2em;padding-top: 0;padding-bottom: 0;margin-top: 0;margin-bottom: 0">
            In <b>pan-cancer analysis</b>, we added the analysis of cell type statistics and functional status score across cancer types, as well as the assessment of TLS scores.
          </p>
        </div>
      </div>
    </div>
    <div class="my-container">
      <h2>
        Cite CancerSRT
      </h2>
      <div class="my-div-center">
        <div style="text-align: justify;width: 80%;word-spacing: 5px;line-height: 30px;font-size: 18px;margin-bottom: 5px;color: black">
          <p style="text-indent: 2em">
            Human Cancer SRT Database: a database for spatially resolved transcriptomes.
          </p>
        </div>
      </div>
    </div>


    <div class="my-container">
      <h2>
        Useful link
      </h2>
      <br/>
      <div style="width: 800px; height: 100px; margin: auto">
        <el-carousel :interval="4000" type="card" height="100px">
          <el-carousel-item v-for="item in img_source" :key="item">
            <a :href=item.url target="_blank">
              <img :src="item.img" style="height: 100%;object-fit: cover" alt=""/>
            </a>
          </el-carousel-item>
        </el-carousel>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      form: {
        Type: '',
        Gene: ''
      },
      options: [
        {
          value: '0',
          label: 'all'
        }, {
          value: '1',
          label: 'human'
        }
      ],
      //ciyun
      tagList: [],
      radius: 120,
      dtr: Math.PI / 180,
      d: 300,
      mcList: [],
      active: false,
      lasta: 1,
      lastb: 1,
      distr: true,
      tspeed: 10,
      size: 250,
      mouseX: 0,
      mouseY: 0,
      howElliptical: 1,
      oList: null,
      oA: null,
      sa: 0,
      ca: 0,
      sb: 0,
      cb: 0,
      sc: 0,
      cc: 0,
      img_source: [
        {
          img: require('../../assets/Home/10x.png'),
          url: 'https://www.10xgenomics.com/',
        },
        {
          img: require('../../assets/Home/zenodo.png'),
          url: 'https://zenodo.org/',
        },
        {
          img: require('../../assets/Home/SORC.png'),
          url: 'http://bio-bigdata.hrbmu.edu.cn/SORC/',
        },
        {
          img: require('../../assets/Home/SPASCER.png'),
          url: 'https://ccsm.uth.edu/SPASCER/',
        },
        {
          img: require('../../assets/Home/spatialDB.png'),
          url: 'http://www.spatialomics.org/SpatialDB/',
        },
        {
          img: require('../../assets/Home/SOAR.png'),
          url: 'https://soar.fsm.northwestern.edu/',
        },
        {
          img: require('../../assets/Home/SODB.png'),
          url: 'https://gene.ai.tencent.com/SpatialOmics/',
        },
        {
          img: require('../../assets/Home/STOmicsDB.png'),
          url: 'https://db.cngb.org/stomics/',
        },

      ]
    };
  },
  methods: {
    routerTo(cancerNO, cancerName) {
      console.log(cancerNO,cancerName)
      this.$router.push({
        path: '/Dataset/type/'+cancerName
      })
    },
    onSubmit(){
      let _this = this
      console.log(_this.form)
      _this.$router.push({
        path: '/Search',
        query: _this.form
      })
    },

    //ciynn
    // 生成随机数
    getRandomNum() {
      return Math.floor(Math.random() * (255 + 1));
    },
    // 三角函数角度计算
    sineCosine(a, b, c) {
      this.sa = Math.sin(a * this.dtr);
      this.ca = Math.cos(a * this.dtr);
      this.sb = Math.sin(b * this.dtr);
      this.cb = Math.cos(b * this.dtr);
      this.sc = Math.sin(c * this.dtr);
      this.cc = Math.cos(c * this.dtr);
    },
    // 设置初始定位
    positionAll() {
      this.$nextTick(() => {      // 注意: 所有的在onReady方法中执行的方法都需要$nextTick确保所有的标签都已经渲染
        var phi = 0;
        var theta = 0;
        var max = this.mcList.length;
        var aTmp = [];
        var oFragment = document.createDocumentFragment();
        // 随机排序
        for (let i = 0; i < this.tagList.length; i++) {
          aTmp.push(this.oA[i]);
        }
        aTmp.sort(() => {
          return Math.random() < 0.5 ? 1 : -1;
        });
        for (let i = 0; i < aTmp.length; i++) {
          oFragment.appendChild(aTmp[i]);
        }
        this.oList.appendChild(oFragment);
        for (let i = 1; i < max + 1; i++) {
          if (this.distr) {
            phi = Math.acos(-1 + (2 * i - 1) / max);
            theta = Math.sqrt(max * Math.PI) * phi;
          } else {
            phi = Math.random() * (Math.PI);
            theta = Math.random() * (2 * Math.PI);
          }
          // 坐标变换
          this.mcList[i - 1].cx = this.radius * Math.cos(theta) * Math.sin(phi);
          this.mcList[i - 1].cy = this.radius * Math.sin(theta) * Math.sin(phi);
          this.mcList[i - 1].cz = this.radius * Math.cos(phi);
          this.oA[i - 1].style.left = this.mcList[i - 1].cx + this.oList.offsetWidth / 2 - this.mcList[i - 1].offsetWidth / 2 + 'px';
          this.oA[i - 1].style.top = this.mcList[i - 1].cy + this.oList.offsetHeight / 2 - this.mcList[i - 1].offsetHeight / 2 + 'px';
        }
      })
    },
    // 坐标更新 让标签动起来
    update() {
      this.$nextTick(() => {           // 注意: 所有的在onReady方法中执行的方法都需要$nextTick确保所有的标签都已经渲染
        var a;
        var b;
        if (this.active) {
          a = (-Math.min(Math.max(-this.mouseY, -this.size), this.size) / this.radius) * this.tspeed;
          b = (Math.min(Math.max(-this.mouseX, -this.size), this.size) / this.radius) * this.tspeed;
        } else {
          a = this.lasta * 0.98;
          b = this.lastb * 0.98;
        }
        this.lasta = a;
        this.lastb = b;
        if (Math.abs(a) <= 0.01 && Math.abs(b) <= 0.01) {
          return
        }
        var c = 0;
        this.sineCosine(a, b, c);
        for (var j = 0; j < this.mcList.length; j++) {
          var rx1 = this.mcList[j].cx;
          var ry1 = this.mcList[j].cy * this.ca + this.mcList[j].cz * (-this.sa);
          var rz1 = this.mcList[j].cy * this.sa + this.mcList[j].cz * this.ca;
          var rx2 = rx1 * this.cb + rz1 * this.sb;
          var ry2 = ry1;
          var rz2 = rx1 * (-this.sb) + rz1 * this.cb;
          var rx3 = rx2 * this.cc + ry2 * (-this.sc);
          var ry3 = rx2 * this.sc + ry2 * this.cc;
          var rz3 = rz2;
          this.mcList[j].cx = rx3;
          this.mcList[j].cy = ry3;
          this.mcList[j].cz = rz3;
          var per = this.d / (this.d + rz3);
          this.mcList[j].x = (this.howElliptical * rx3 * per) - (this.howElliptical * 2);
          this.mcList[j].y = ry3 * per;
          this.mcList[j].scale = per;
          this.mcList[j].alpha = per;
          this.mcList[j].alpha = (this.mcList[j].alpha - 0.6) * (10 / 6);
        }
        this.doPosition();
        this.depthSort();
      })
    },
    //
    doPosition() {
      this.$nextTick(() => {            // 注意: 所有的在onReady方法中执行的方法都需要$nextTick确保所有的标签都已经渲染
        var l = this.oList.offsetWidth / 2;
        var t = this.oList.offsetHeight / 2;
        for (var i = 0; i < this.mcList.length; i++) {
          this.oA[i].style.left = this.mcList[i].cx + l - this.mcList[i].offsetWidth / 2 + 'px';
          this.oA[i].style.top = this.mcList[i].cy + t - this.mcList[i].offsetHeight / 2 + 'px';
          this.oA[i].style.fontSize = Math.ceil(12 * this.mcList[i].scale / 2) + 8 + 'px';
          // this.oA[i].style.filter = "alpha(opacity=" + 100 * this.mcList[i].alpha + ")";
          this.oA[i].style.opacity = this.mcList[i].alpha;
        }
      })
    },
    //
    depthSort() {
      this.$nextTick(() => {            // 注意: 所有的在onReady方法中执行的方法都需要$nextTick确保所有的标签都已经渲染
        var aTmp = [];
        for (let i = 0; i < this.oA.length; i++) {
          aTmp.push(this.oA[i]);
        }
        aTmp.sort(function (vItem1, vItem2) {
          if (vItem1.cz > vItem2.cz) {
            return -1;
          } else if (vItem1.cz < vItem2.cz) {
            return 1;
          } else {
            return 0;
          }
        });
        for (let i = 0; i < aTmp.length; i++) {
          aTmp[i].style.zIndex = i;
        }
      })
    },
    // 网络请求 拿到tagList
    query() {
      // 假装从接口拿回来的数据
      let tagListOrg = [
      //     <!--            <div v-on:click="routerTo(3,'ProstateCancer')">ProstateCancer</div>-->
      // <!--            <div v-on:click="routerTo(4,'Melanoma')">Melanoma</div>-->
      // <!--            <div v-on:click="routerTo(1,'SkinCancer')">SkinCancer</div>-->
      // <!--            <div v-on:click="routerTo(7,'ColonCancer')">ColonCancer</div>-->
      // <!--            <div v-on:click="routerTo(8,'KidneyCancer')">LiverCancer</div>-->
      // <!--            <div v-on:click="routerTo(0,'BreastCancer')">BreastCancer</div>-->
      // <!--            <div v-on:click="routerTo(5,'OvarianCancer')">OvarianCancer</div>-->
      // <!--            <div v-on:click="routerTo(6,'Glioblastoma')">Glioblastoma</div>-->
      // <!--            <div v-on:click="routerTo(2,'PDAC')">PDAC</div>-->
      // <!--            <div v-on:click="routerTo(9,'LungCancer')">LungCancer</div>-->
        { name: 'ProstateCancer', url: '/Dataset/type/ProstateCancer' },
        { name: 'Melanoma', url: '/Dataset/type/Melanoma' },
        { name: 'SkinCancer', url: '/Dataset/type/SkinCancer' },
        { name: 'ColonCancer', url: '/Dataset/type/ColorectalCancer' },
        { name: 'LiverCancer', url: '/Dataset/type/LiverCancer' },
        { name: 'BreastCancer', url: '/Dataset/type/BreastCancer' },
        { name: 'OvarianCancer', url: '/Dataset/type/OvarianCancer' },
        { name: 'Glioblastoma', url: '/Dataset/type/Glioblastoma' },
        { name: 'PDAC', url: '/Dataset/type/PDAC' },
        { name: 'LungCancer', url: '/Dataset/type/LungCancer' },
        // { name: 'IntestineCancer', url: '/Dataset/type/IntestineCancer' },
        { name: 'BladderCancer', url: '/Dataset/type/BladderCancer' },
        { name: 'CervicalCancer', url: '/Dataset/type/CervicalCancer' },
        { name: 'BrainMetastases', url: '/Dataset/type/Brainmetastases' },
        { name: 'HeadAndNeckCancer', url: '/Dataset/type/HeadAndNeckCancer' },
      ];
      // 给tagList添加随机颜色
      tagListOrg.forEach(item => {
        // item.color = "rgb(0,0,0)";
        item.color = "rgb(" + this.getRandomNum() + "," + this.getRandomNum() + "," + this.getRandomNum() + ")";
      })
      this.tagList = tagListOrg;
      console.log(this.tagList)
      this.onReady();
    },
    // 生成标签云
    onReady() {
      this.$nextTick(() => {
        this.oList = this.$refs.tagcloudall;
        this.oA = this.oList.getElementsByTagName('a')
        var oTag = null;
        for (var i = 0; i < this.oA.length; i++) {
          oTag = {};
          oTag.offsetWidth = this.oA[i].offsetWidth;
          oTag.offsetHeight = this.oA[i].offsetHeight;
          this.mcList.push(oTag);
        }
        this.sineCosine(0, 0, 0);
        this.positionAll();
        this.oList.onmouseover = () => {
          this.active = true;
        }
        this.oList.onmouseout = () => {
          this.active = false;
        }
        this.oList.onmousemove = (event) => {
          var oEvent = window.event || event;

          this.mouseX = oEvent.clientX - (this.oList.offsetLeft + this.oList.offsetWidth / 2);
          this.mouseY = oEvent.clientY - (this.oList.offsetTop + this.oList.offsetHeight / 2);
          this.mouseX /= 5;
          this.mouseY /= 5;
        }
        setInterval(() => {
          this.update()
        }, 30);            // 定时器执行 不能写setInterval(this.update(), 30)
      })
  }
  },
  created() {
    this.$nextTick(() => {
      this.query();
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#content{
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  /*background-color: #FFFFFF;*/
  /*background-color: #FFFFFF;*/
}
#right{
  flex: 1;
  /*width: 300px;*/
  margin: 0 0 0 10px;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  background-color: #FFFFFF;
  z-index: 0;
  /*margin-right: 10px;*/
}
#tag_list{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
#tag_list div{
  margin: 5px;
  color: blue;
  text-decoration:underline;
  cursor: pointer;
}
.tagcloud-all {
  position: relative;
  height: 260px;
  /*width: 90%;*/
  min-width: 270px;
  /*border: #696969 solid 1px;*/
}
.tagcloud-all a {
  position: absolute;
  top: 0;
  /*left: 0;*/
  color: #000000;
  font-weight: bold;
  text-decoration: none;
  padding: 3px 6px;
}
.tagcloud-all a:hover {
  color: #FF0000;
  letter-spacing: 2px;
  background-color: #FFFF00;
}


#statistic{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-width: 350px;
}
#statistic_form .el-form-item{
  min-width: 350px;
  margin: 0;
  padding: 0;
}

#left{
  width: 65%;
  min-width: 748px;
  /*width: 750px;*/
  height: 550px;
  position:relative;
  display: flex;
  flex-direction: column;
  /*cursor: pointer;*/
  z-index: 1;
  background-color: #FFFFFF;
  /*margin-top: 10px;*/
  /*border: #696969 solid 1px;*/
}

#background {
  /*top: 0;*/
  left: 150px;
  position:absolute;
  top:50%;
  /*left:50%;*/
  margin-top:-230px;
  /*margin-left:-350px;*/
  width: 617px;
  height: 500px;
  background-image: url("../../assets/Home/home2_500.png");
  background-repeat: no-repeat;
  z-index: -1;
}

#ProstateCancer {
  position: absolute;
  width: 80px;
  height: 80px;
  left: 456px;
  top: 222px;
  /*background-color: blue;*/
  /*opacity: 0.2;*/
  cursor:pointer;
}
#SkinCancer {
  position: absolute;
  width: 80px;
  height: 80px;
  left: 46px;
  top: 222px;
  /*background-color: yellow;*/
  /*opacity: 0.2;*/
  cursor:pointer;
}
#LiverCancer {
  position: absolute;
  width: 80px;
  height: 80px;
  left: 64px;
  top: 132px;
  /*background-color: orange;*/
  /*opacity: 0.2;*/
  cursor:pointer;
}
/*#IntestineCancer {*/
/*  position: absolute;*/
/*  width: 130px;*/
/*  height: 120px;*/
/*  left: 140px;*/
/*  top: 370px;*/
/*  background-color: purple;*/
/*  opacity: 0.2;*/
/*  cursor:pointer;*/
/*}*/
#PDAC{
  position: absolute;
  width: 80px;
  height: 80px;
  left: 250px;
  top: 401px;
  /*background-color: red;*/
  /*opacity: 0.2;*/
  cursor:pointer;
}
#BladderCancer{
  position: absolute;
  width: 80px;
  height: 80px;
  left: 342px;
  top: 375px;
  /*background-color: purple;*/
  /*opacity: 0.2;*/
  cursor:pointer;
}
#Glioblastoma{
  position: absolute;
  width: 80px;
  height: 80px;
  left: 300px;
  top: 4px;
  /*background-color: green;*/
  /*opacity: 0.2;*/
  cursor:pointer;
}

#BreastCancer {
  position: absolute;
  width: 80px;
  height: 80px;
  left: 116px;
  top: 50px;
  /*background-color: blue;*/
  /*opacity: 0.2;*/
  cursor:pointer;
}
#OvarianCancer {
  position: absolute;
  width: 80px;
  height: 80px;
  left: 101px;
  top: 302px;
  /*background-color: yellow;*/
  /*opacity: 0.2;*/
  cursor:pointer;
}
#ColonCancer {
  position: absolute;
  width: 80px;
  height: 80px;
  left: 160px;
  top: 374px;
  /*background-color: orange;*/
  /*opacity: 0.2;*/
  cursor:pointer;
}
#CervicalCancer {
  position: absolute;
  width: 80px;
  height: 80px;
  left: 389px;
  top: 50px;
  /*background-color: purple;*/
  /*opacity: 0.2;*/
  cursor:pointer;
}
#BrainMetastases{
  position: absolute;
  width: 80px;
  height: 80px;
  left: 204px;
  top: 3px;
  /*background-color: red;*/
  /*opacity: 0.2;*/
  cursor:pointer;
}
#Melanoma{
  position: absolute;
  width: 80px;
  height: 80px;
  left: 409px;
  top: 302px;
  /*background-color: purple;*/
  /*opacity: 0.2;*/
  cursor:pointer;
}
#LungCancer{
  position: absolute;
  width: 80px;
  height: 80px;
  left: 440px;
  top: 132px;
  /*background-color: green;*/
  /*opacity: 0.2;*/
  cursor:pointer;
}
#search_button_home{
  color: #FFFFFF;
  background-color: #173161;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
</style>
